import { useDispatch } from 'react-redux';
import { ScrollPosts } from '../store/actions/ScrollAction';
export const useScrollPosts = () => {
  const dispatch = useDispatch();
  const handleScroll = () => {
    dispatch(ScrollPosts());
  };
  return { handleScroll };
};
